import { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';

const WerkplaatsVideosSection = () => {
  const navigate = useNavigate();
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const videos = sectionRef.current?.querySelectorAll('video');
    if (!videos) return;
    videos.forEach(v => {
      v.muted = true;
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
    });
    const tryPlayAll = () => videos.forEach(v => v.play().catch(() => {}));
    tryPlayAll();
    const forcePlay = () => { tryPlayAll(); document.removeEventListener('touchstart', forcePlay); };
    document.addEventListener('click', forcePlay, { once: true });
    document.addEventListener('touchstart', forcePlay, { once: true });
    return () => { document.removeEventListener('touchstart', forcePlay); };
  }, []);

  return (
    <section className="w-full py-16 md:py-36 lg:py-44 bg-white" ref={sectionRef}>
      <div className="max-w-[1400px] mx-auto px-6 sm:px-8 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-24 items-center">
          {/* Text + CTA - 7 columns */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-7"
          >
            <p
              className="text-lg sm:text-xl md:text-2xl lg:text-[1.65rem] font-normal text-black leading-[2.5] tracking-normal mb-14"
              style={{ fontFamily: "'Manrope', sans-serif" }}
            >
              In onze werkplaats combineren wij vakmanschap met de nieuwste technologie. Van chiptuning tot complete modificaties, elk voertuig krijgt de aandacht die het verdient.
            </p>

            <Button
              onClick={() => navigate('/expertises')}
              className="bg-black hover:bg-neutral-800 text-white text-xs font-semibold px-8 py-5 h-auto rounded-full uppercase tracking-[0.15em] transition-colors"
            >
              Bekijk onze expertises
            </Button>
          </motion.div>

          {/* Videos - 5 columns */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.15 }}
            className="lg:col-span-5 flex gap-3 md:gap-4"
          >
            <div className="flex-1 rounded-2xl overflow-hidden aspect-[9/16] max-h-[50vh] md:max-h-none">
              <video
                className="w-full h-full object-cover"
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
              >
                <source
                  src="https://lozejxkhsvwkksgzhrfd.supabase.co/storage/v1/object/public/images/Vermado_rs7%20sportback%20ecu%20tuning_video%20(1).mp4"
                  type="video/mp4"
                />
              </video>
            </div>
            <div className="flex-1 rounded-2xl overflow-hidden aspect-[9/16] mt-8 md:mt-12 max-h-[50vh] md:max-h-none">
              <video
                className="w-full h-full object-cover"
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
              >
                <source
                  src="https://lozejxkhsvwkksgzhrfd.supabase.co/storage/v1/object/public/images/Vermado_kenteken%20clipjes_video%20(1).mp4"
                  type="video/mp4"
                />
              </video>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WerkplaatsVideosSection;
